import { createLogic } from 'redux-logic';

export const name = 'ui';

const getState = state => state[name];

export const ModalTypes = {
  Login: 'Login',
  ResetPassword: 'ResetPassword',
  Registration: 'Registration',
  SetPassword: 'SetPassword',
  Contact: 'Contact',
  Support: 'Support',
};

/*
 * TYPES
 */

const prefix = `pages/${name}/ `;

const UPDATE_UI = `${prefix}UPDATE_UI`;

const SHOW_MODAL = `${prefix}SHOW_MODAL`;

const HIDE_MODAL = `${prefix}HIDE_MODAL`;

/*
 * ACTIONS
 */

const updateUi = options => ({ type: UPDATE_UI, options });

const showModal = options => ({ type: SHOW_MODAL, options });

const hideModal = options => ({ type: HIDE_MODAL, options });

/*
 * REDUCER
 */

const initialState = {
  footerVisible: true,
  isRegistrationOpened: null,
  isLoginOpened: null,
  isResetPasswordOpened: null,
  isSetPasswordOpened: null,
  isContactModalOpened: null,
  scrollPosition: 0,
  modalType: null,
  modalProps: {},
};

const reducer = (state = initialState, action) => {
  const actions = {
    [UPDATE_UI]: () => ({
      ...state,
      ...action.options
    }),
    [SHOW_MODAL]: () => ({
      ...state,
      modalType: action.options.modalType,
      modalProps: action.options.modalProps || {},
    }),
    [HIDE_MODAL]: () => ({
      ...state,
      modalType: null,
      modalProps: {},
    }),
  };

  return (actions[action.type] && actions[action.type]()) || state;
};

/*
 * LOGIC
 */

const updateUiLogic = createLogic({
  type: UPDATE_UI,
  process({ action: { payload } }) {
    return Promise.resolve();
  },
});

/*
 * SELECTORS
 */

const isFooterVisible = state => getState(state).footerVisible;
const isRegistrationOpened = state => getState(state).isRegistrationOpened;
const isLoginOpened = state => getState(state).isLoginOpened;
const isResetPasswordOpened = state => getState(state).isResetPasswordOpened;
const isSetPasswordOpened = state => getState(state).isSetPasswordOpened;
const isContactModalOpened = state => getState(state).isContactModalOpened;
const scrollPosition = state => getState(state).scrollPosition;
const getModal = state => {return {modalType: getState(state).modalType, modalProps: getState(state).modalProps}};

/*
 * EXPORTS
 */

export default reducer;

export const actions = {
  updateUi,
  showModal,
  hideModal,
};

export const types = {
  UPDATE_UI,
};

export const logic = {
  updateUiLogic,
};

export const selectors = {
  isFooterVisible,
  isRegistrationOpened,
  isLoginOpened,
  isResetPasswordOpened,
  isSetPasswordOpened,
  isContactModalOpened,
  getModal,
  scrollPosition,
};
